import { render, staticRenderFns } from "./Hdyx.vue?vue&type=template&id=c2cd2d70&scoped=true"
import script from "./Hdyx.vue?vue&type=script&lang=js"
export * from "./Hdyx.vue?vue&type=script&lang=js"
import style0 from "./Hdyx.vue?vue&type=style&index=0&id=c2cd2d70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cd2d70",
  null
  
)

export default component.exports